export const GET_NEXT_INSURED_ITEMS_SUCCESS = 'GET_NEXT_INSURED_ITEMS_SUCCESS';
export const GET_INSURED_ITEMS_SUCCESS = 'GET_INSURED_ITEMS_SUCCESS';
export const GET_INSURED_ITEM_REQUEST = 'GET_INSURED_ITEM_REQUEST';
export const GET_INSURED_ITEM_SUCCESS = 'GET_INSURED_ITEM_SUCCESS';
export const GET_INSURED_ITEM_ERROR = 'GET_INSURED_ITEM_ERROR';
